import {gemStore} from 'app/gemStore';

export const setPrintingAction = (printing: boolean) => gemStore.getState().setPrinting(printing);
